import { render } from "./persionalInfo.vue?vue&type=template&id=5444c884&scoped=true"
import script from "./persionalInfo.vue?vue&type=script&lang=js"
export * from "./persionalInfo.vue?vue&type=script&lang=js"

import "./persionalInfo.vue?vue&type=style&index=0&id=5444c884&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5444c884"]])

export default __exports__